import { useAppUpdateStore } from '@/hooks/use-update-app.ts'

import { registerServiceWorker } from './register-service-worker.ts'

const swUrl = `/${
  import.meta.env.MODE === 'production' ? 'sw.js' : 'dev-sw.js?dev-sw'
}`

export const initServiceWorker = () =>
  registerServiceWorker({
    url: swUrl,
    onUpdateFound: () => {
      useAppUpdateStore.setState({ hadUpdateAt: new Date() })
    },
    updatePollingIntervalSeconds: 60 * 2, // 2 minutes
  })
